import { compose } from 'ramda'

import {
  updateDeliveryModesStart,
  updateDeliveryModesSuccess,
  updateDeliveryModesFail,
} from 'features/checkout/duck/actions'
import { normalizeDeliveryModes } from 'features/checkout/duck/normalize'
import checkoutSelectors from 'features/checkout/duck/selectors'
import { postDeliveryModes } from 'features/checkout/requests'
import { Address } from 'features/checkout/types'
import { ThunkResult } from 'redux/types'

import { addressError } from '../address'

export const operationUpdateDeliveryModes =
  (deliveryAddress: Address | undefined): ThunkResult<Promise<void>> =>
  async (dispatch, getState) => {
    if (deliveryAddress) {
      dispatch(updateDeliveryModesStart())
      try {
        const state = getState()
        const deliveryModeList = await postDeliveryModes(deliveryAddress)
        const selectedDeliverySpeed = checkoutSelectors.getSelectedDeliverySpeedCode(state)
        const previouslyUsedPickupPlace = checkoutSelectors.getPreviouslyUsedPickupPlace(state)
        const deliveryModesSettings = checkoutSelectors.getDeliveryModesSettings(state)
        const deliveryModesFullList = deliveryModeList.map((mode) => ({
          ...mode,
          ...deliveryModesSettings[mode.code],
        }))
        const normalizedDeliveryModes = normalizeDeliveryModes({
          deliveryModeList: deliveryModesFullList,
          selectedDeliverySpeed,
          previouslyUsedPickupPlace,
          deliveryAddress,
        })
        dispatch(updateDeliveryModesSuccess(normalizedDeliveryModes))
      } catch (error) {
        compose(
          dispatch,
          updateDeliveryModesFail,
          dispatch,
          addressError,
        )(error, deliveryAddress.id)
      }
    }
  }
